import $ from 'jquery';
window.jQuery = $;
window.$ = $;
global.jQuery = $;
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap'
import 'animate.css'

import 'tipso/src/tipso.min.css'
import 'tipso/src/tipso.min.js'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { getMsalInstance } from './auth/entraMsal'
import store from './store'
import Fragment from 'vue-fragment'
import axios from 'axios'
import VueAxios from 'vue-axios'
import UUID from "vue-uuid";
import VuePlyr from 'vue-plyr'
import 'plyr/dist/plyr.css'
import moment from 'moment'

Vue.use(Fragment.Plugin)
Vue.use(VueAxios, axios)
Vue.use(UUID);
Vue.prototype.moment = moment

// The second argument is optional and sets the default config values for every player.
Vue.use(VuePlyr, {
    plyr: {
        fullscreen: { enabled: true }
    },
    emit: ['ended']
});

Vue.config.productionTip = false

Vue.filter('s3url', function (value, key) {
    if (value) {
        if (key) {

            if (key == "") {
                key = "file";
            }
            else {
                key = key + "File";
            }

            var file = value[key];
            var fileName = value[key + "Name"];
            if (file && (file instanceof Blob || file instanceof File)) {
                return URL.createObjectURL(file);
            } else if (fileName) {
                return "https://fabricfour.blob.core.windows.net/mhslearning-upload/" + fileName;
            }
        }
        else if (value.file) {
            //if this object has a file object attached to it, it must be a new file property
            return URL.createObjectURL(value.file);

        } else if (value.fileName) {
            //if it has a fileName
            return "https://fabricfour.blob.core.windows.net/mhslearning-upload/" + value.fileName;

        } else if (value.imageFile) {
            //if this object has a file object attached to it, it must be a new file property
            return URL.createObjectURL(value.imageFile);

        } else if (value.imageFileName) {
            //if it has a fileName
            return "https://fabricfour.blob.core.windows.net/mhslearning-upload/" + value.imageFileName;

        } else if (value.profileFileName) {
            //if this object has a file object attached to it, it must be a new file property
            return "https://fabricfour.blob.core.windows.net/mhslearning-upload/" + value.profileFileName;
        }
        else if (value.length) {
            //probably a filename then?
            return "https://fabricfour.blob.core.windows.net/mhslearning-upload/" + value;
        }
    }

    return null;
});

import CourseCardComponent from './components/CourseCardComponent'
Vue.component('course-card-component', CourseCardComponent)

import CoursePackageComponent from './components/CoursePackageComponent'
Vue.component('course-package-component', CoursePackageComponent)

import mixinsWebRequests from "./mixinsWebRequests";
Vue.mixin(mixinsWebRequests);

import mixinsValidation from "./mixinsValidation";
Vue.mixin(mixinsValidation);

const vm = new Vue({
    router,
    render: h => h(App),
    store,
    data() {
        return {
            siteDesign: null,
        }
    },
    mounted: function () {
        //load user state from localStorage

    },
    beforeDestroy() {
        window.removeEventListener("load", this.onLoad);
    },
    beforeMount: function () {
        this.onLoad();
        this.$store.commit("loadUserState");
        this.$store.commit("loadDesignState");
        this.$store.commit("loadCart");
        window.addEventListener("load", this.onLoad);
    },
    methods: {
        //page refresh
        async onLoad() {
            // Entra bullshit shenanigans
            try { 
                const urlHash = window.location.hash || ''
                const looksLikeAuthReturn = urlHash.includes('code=') || urlHash.includes('error=') || urlHash.includes('state=')

                if (looksLikeAuthReturn) {
                    const msalInstance = getMsalInstance()

                    // Convert Vue hash-router style "#/code=..." into MSAL style "#code=..."
                    const msalHash = urlHash.startsWith('#/') ? '#' + urlHash.substring(2) : urlHash

                    const authenticationResult = await msalInstance.handleRedirectPromise(msalHash)

                    if (authenticationResult && authenticationResult.idToken) {
                        sessionStorage.setItem('entraIdToken', authenticationResult.idToken)
                        this.$router.replace({ name: 'AuthCallback' })
                        return
                    }
                }
            } catch (error) {
                console.error('Entra redirect handling failed:', error)
            }

            //load site and site design
            var site = await this.web("/sites/getSiteDesign", "Loading Site Design");
            //set page title
            document.title = site.name;
            var parsed;
            if (site.siteDesign) {
                parsed = JSON.parse(site.siteDesign);
                parsed.paygateId = site.paygateId;
                parsed.autoEnrollment = site.autoEnrollment;
                parsed.useExternalAuthProvider = site.useExternalAuthProvider === true;
                parsed.entraClientID = site.entraClientID || null;
                parsed.entraTenantID = site.entraTenantID || null;

                if (parsed.footer.termsFile) {
                    delete parsed.footer.termsFile;
                }
                //get favicon link add option to site design
                var link = document.querySelector("link[rel~='icon']");
                if (!link) {
                    link = document.createElement('link');
                    link.rel = 'icon';
                    document.getElementsByTagName('head')[0].appendChild(link);
                }
                if (parsed.faviconFileName) {
                    link.href = "https://fabricfour.blob.core.windows.net/mhslearning-upload/" + parsed.faviconFileName;
                }
                else {
                    link.href = "https://fabricfour.blob.core.windows.net/mhslearning-upload/" + parsed.navigation.logoFileName;
                }
            }

            if (parsed.components.length > 0) {
                for (var i = 0; i < parsed.components.length; i++) {
                    var current = parsed.components[i];
                    if (current.courseIds && current.courseIds.length > 0) {
                        current.courses = [];
                        for (var j = 0; j < current.courseIds.length; j++) {

                            try {
                                var courseInfo = await this.web("/courses/info/" + current.courseIds[j], "Loading course", null, [404]);
                                console.log(current.courseIds, courseInfo);

                                if (courseInfo) {
                                    current.courses.push(courseInfo);
                                }
                            }
                            catch (e) {
                                console.log(e);
                            }
                        }
                    }
                    if (current.coursePackageIds && current.coursePackageIds.length > 0) {
                        current.coursePackages = [];
                        for (var j = 0; j < current.coursePackageIds.length; j++) {
                            var coursePackageInfo = await this.web("/coursePackages/" + current.coursePackageIds[j], "Loading course package");
                            if (coursePackageInfo) {
                                current.coursePackages.push(coursePackageInfo);
                            }
                        }
                    }
                }
            }
            //set design and apply css
            this.siteDesign = parsed;
            this.$store.commit("setDesign", parsed);
            this.$store.commit("setSiteId", site.id);
            this.$store.commit("setAdditionalProperties", site.additionalProperties);
            this.$store.commit("setDivisions", site.divisions);
            this.setTheme();
        },
        setTheme() {
            var style = document.createElement('style');
            style.type = 'text/css';
            var css = this.$store.getters.getThemeCss;
            style.innerHTML = css;
            document.getElementsByTagName('head')[0].appendChild(style);
        },
    }
});

vm.$mount('#app');

